// Períodos pré-definidos compartilhados pelos relatórios (logs, meteorológico e aeração).
export const PERIODO_MANUAL = 'manual';

export const PERIODO_OPTIONS = [
    { label: 'Manual', value: PERIODO_MANUAL },
    { label: 'Hoje', value: 'hoje' },
    { label: 'Dia anterior', value: 'ontem' },
    { label: 'Últimos 7 dias', value: '7d' },
    { label: 'Últimos 15 dias', value: '15d' },
    { label: 'Últimos 30 dias', value: '30d' },
    { label: 'Desde o início do mês atual', value: 'mes' },
];

// Data local em YYYY-MM-DD (toISOString usa UTC e vira o dia à noite no Brasil).
export const formatarDataLocal = (d) => {
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const dia = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${mes}-${dia}`;
};

export const hojeLocal = () => formatarDataLocal(new Date());

const diasAtras = (n) => {
    const d = new Date();
    d.setDate(d.getDate() - n);
    return formatarDataLocal(d);
};

// Intervalo { dataInicio, dataFinal } do período; null para o modo manual.
export const getDatasPeriodo = (periodo) => {
    const hoje = hojeLocal();
    switch (periodo) {
        case 'hoje': return { dataInicio: hoje, dataFinal: hoje };
        case 'ontem': { const ontem = diasAtras(1); return { dataInicio: ontem, dataFinal: ontem }; }
        case '7d': return { dataInicio: diasAtras(7), dataFinal: hoje };
        case '15d': return { dataInicio: diasAtras(15), dataFinal: hoje };
        case '30d': return { dataInicio: diasAtras(30), dataFinal: hoje };
        case 'mes': {
            const d = new Date();
            return { dataInicio: formatarDataLocal(new Date(d.getFullYear(), d.getMonth(), 1)), dataFinal: hoje };
        }
        default: return null;
    }
};
